import { ref } from 'vue'
import type { SuperelectricInkApi } from './tauriBridge'

let api: SuperelectricInkApi
export const isPlatformWeb = ref(typeof window !== 'undefined' && !('__TAURI_INTERNALS__' in window))
export const isDesktopPlatform = ref(false)

export async function initPlatformBridge(): Promise<SuperelectricInkApi> {
  if (api) return api

  const isTauri = typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window

  if (isTauri) {
    isPlatformWeb.value = false
    const { createTauriBridge } = await import('./tauriBridge')
    api = await createTauriBridge()
    isDesktopPlatform.value = await api.isDesktopPlatform()
  } else {
    isPlatformWeb.value = true
    const { createWebBridge } = await import('./webBridge')
    api = await createWebBridge()
    isDesktopPlatform.value = false
  }

  if (typeof window !== 'undefined') {
    ;(window as any).api = api
  }
  return api
}

export function getPlatformBridge(): SuperelectricInkApi {
  if (!api && typeof window !== 'undefined' && (window as any).api) {
    return (window as any).api
  }
  return api
}
